import { mediaItems } from '@/mocks/homeData';
import ImageBox from '@/components/base/ImageBox';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-extrabold text-foreground-950 font-heading mb-3">
            视频爆料
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精选视频内容，多角度呈现娱乐圈精彩瞬间
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {mediaItems.map((item, i) => (
            <article
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors group cursor-pointer"
            >
              <ImageBox
                src={item.image}
                alt={item.title}
                title={`吃瓜网51视频 - ${item.title}`}
                className="relative w-full aspect-[16/9] overflow-hidden bg-background-100"
                imgClassName="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              >
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded-md bg-black/60 text-background-50 text-[11px] font-medium whitespace-nowrap">
                  {item.duration}
                </div>
              </ImageBox>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 mb-2 font-heading line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}